export function projectFilters() {

    let filters     = document.querySelectorAll('.js-project-filter');
    let projects    = document.querySelectorAll('.js-project-item');

   if(filters) {
       filters.forEach((filter) => {

           filter.addEventListener('change', () => {
               let selected = filter.querySelector('option:checked').getAttribute('data-item-id');

               projects.forEach((project) => {
                  project.classList.add('d-none');
               });

               if(selected != '0') {
                   document.querySelector(`.js-project-item[data-category-id="${selected}"]`).classList.remove('d-none');
               } else {
                   projects.forEach((project) => {
                       project.classList.remove('d-none');
                   });
               }
           });
       });
   }

    return 'projectFilters';
}
